import React from "react";

// 게이밍/스티어링 휠 모양 SVG 아이콘 — 이모지(🎮) 대신 디자인 통일용.
// currentColor 를 사용하므로 부모 색상을 그대로 따른다.
interface SteeringWheelIconProps {
  className?: string;
  title?: string;
}

const SteeringWheelIconComponent = ({
  className,
  title,
}: SteeringWheelIconProps) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    role="img"
    aria-hidden={title ? undefined : true}
    aria-label={title}
  >
    {title ? <title>{title}</title> : null}
    {/* 림(테두리) */}
    <circle cx="12" cy="12" r="9" />
    {/* 허브(중앙) */}
    <circle cx="12" cy="12" r="2.5" />
    {/* 스포크 3개 — 좌/우/하 */}
    <line x1="4.3" y1="13" x2="9.6" y2="12.3" />
    <line x1="19.7" y1="13" x2="14.4" y2="12.3" />
    <line x1="12" y1="14.5" x2="12" y2="21" />
  </svg>
);

SteeringWheelIconComponent.displayName = "SteeringWheelIcon";

export const SteeringWheelIcon = React.memo(SteeringWheelIconComponent);
